import { render, staticRenderFns } from "./OpenCard.vue?vue&type=template&id=0b15ec66&scoped=true&"
import script from "./OpenCard.vue?vue&type=script&lang=js&"
export * from "./OpenCard.vue?vue&type=script&lang=js&"
import style0 from "./OpenCard.vue?vue&type=style&index=0&id=0b15ec66&scoped=true&lang=scss&"
import style1 from "./OpenCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b15ec66",
  null
  
)

export default component.exports